import React from 'react'
import partnerConstants from '../constants/partner.constants'
import planaltoImage from '../../../../assets/images/troque-seus-pontos/planalto.png'
import moveflexStoreImage from '../../../../assets/images/troque-seus-pontos/loja-muviflex.png'
import liveloImage from '../../../../assets/images/troque-seus-pontos/livelo.png'
import RadioButton from './../../../components/form-components/radio-button.component'
import { StyledImageStoreContainer } from './../../../components/containers/flex-container.component'
import styled from 'styled-components'
import { breakpoints } from '././../../../constants'

const partners = [
	{
		name: partnerConstants.MOVEFLEX_STORE,
		image: moveflexStoreImage,
	},
	// {
	// 	name: partnerConstants.LIVELO,
	// 	image: liveloImage
	// }
]

const PartnerSelect = (props) => (
	<StyledImageStoreContainer>
		{partners.map(renderPartner.bind(null, props))}
	</StyledImageStoreContainer>
)

const StyledImg = styled.img`
	width: 100%;

	&.livelo {
		width: 57px;
		max-width: 127px;
		max-height: 97px;

		@media screen and (min-width: 1128px) {
			width: 85px;
		}

		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			width: 101px;
		}

		@media screen and (min-width: 1440px) {
			width: 118px;
		}
	}
`

function renderPartner({ onSelect, selected }, { name, image }, index) {
	return (
		<RadioButton
			className={`col-3 sm-4 ${name}`}
			key={index}
			isActive={name == selected}
			onClick={() => onSelect(name)}>
			<StyledImg src={image} title={name} alt={name} className={name} />
		</RadioButton>
	)
}

export default PartnerSelect
